var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "margin-bottom-3xl", attrs: { id: "icons-header" } },
    [
      _c(
        "div",
        { staticClass: "margin-bottom-3xl margin-auto laptop:line-length-xl" },
        [
          _c("h1", { staticClass: "sr-only" }, [_vm._v("Font Awesome Icons")]),
          _vm._v(" "),
          _c("input-term", {
            staticStyle: { "--input-placeholder-color": "var(--fa-md-gravy)" },
            attrs: {
              "auto-focus": false,
              term: _vm.term,
              "is-showing-go-button": !!_vm.term,
              label: `Search the v${_vm.$releases.active.versionParts.major} Icons`,
            },
            on: { input: (newTerm) => (_vm.term = newTerm), go: _vm.goSearch },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("icons-stats"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }